
namespace TabAurous.Sales {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class MaterialOutDialog extends _Ext.TransDialog<MaterialOutRow, any> {

        protected getFormKey() { return MaterialOutForm.formKey; }
        protected getIdProperty() { return MaterialOutRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialOutRow.localTextPrefix; }
        protected getNameProperty() { return MaterialOutRow.nameProperty; }
        protected getService() { return MaterialOutService.baseUrl; }
        protected getDeletePermission() { return MaterialOutRow.deletePermission; }
        protected getInsertPermission() { return MaterialOutRow.insertPermission; }
        protected getUpdatePermission() { return MaterialOutRow.updatePermission; }

        public form = new MaterialOutForm(this.idPrefix);

        contractTotals: string;

        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 150;
            q.initItemEditor(this, this.form.ItemDetails, Config);
            //Make grid full width
            q.hideEditorLabel(this.form.ItemDetails);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            //q.hideEditorLabel(this.form.TaxDetails);
            q.setTextRightAlign(this.form.NetAmount);
            q.setTextRightAlign(this.form.AdditionalCharges);
            q.setTextRightAlign(this.form.GrossAmount);
            q.setTextRightAlign(this.form.Discount);
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.hideCaption(this.form.LedgerName);
            // q.setTextRightAlign(this.form.TaxAmount);
            q.setGridEditorHeight(this.form.ItemDetails, 300);
            //q.setGridEditorHeight(this.form.TaxDetails, 150);
            q.hideEditorTab
            //this.form.TaxDetails.getGridField().find('.grid-toolbar').attr("style", "display:none;");
            this.form.ItemDetails.slickGrid.setOptions({ forceFitColumns: true });
            //q.hideCaption(this.form.Posted);
            //To Show Image on Right Top & Hide Categories
            q.SetCategorySixColumn(this.form.TransDate);
            q.SetCategoryFourColumn(this.form.BillNo);
            q.SetCategoryFullWidth(this.form.ItemDetails);
            q.SetSix12Column(this.form.FinancialYearId);
            q.SetCategoryTwoColumn(this.form.Pieces);
            q.SetCategoryFourColumn(this.form.NetAmount);
            q.SetCategoryFullWidth(this.form.Remark);
            q.HideCategoryLable(this.element);
            this.form.LedgerName.getGridField().find('.caption').attr('Style', 'display:none');


            // **** Get Party Details using PartyID **** 
            this.form.PartyId.changeSelect2(e => {

                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            });

            this.form.CurrencyId.changeSelect2(e => {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            });

            //this.form.DepartmentId.changeSelect2(e => {
            //    this.form.ItemDetails.DeptId = parseInt(this.form.DepartmentId.value);
            //});



            // **** Calculate Net,Gross Amount, Discount and Tax from Item Details and show on form ****
            var ItemTotal = 0;
            var Items: any;

            (this.form.ItemDetails.view as any).onRowCountChanged.subscribe(() => {
                Items = this.form.ItemDetails.getItems();
                var TotalItems = this.form.ItemDetails.getItems().length;
                if (Items.length == TotalItems) {
                    this.CalculateAmountandTax(Items, ItemTotal, TotalItems);
                }
            });

            var fieldEditor: JQuery = this.form.PartyId.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );
        }

        protected inplaceSearchClick(e: any): void {
            var grid = OMS.VendorGrid;
            var pickerDialog = new _Ext.GridItemPickerDialog({
                gridType: grid, multiple: false, title: "Select Vendor"
            });

            pickerDialog.onSuccess = (selectedItems: OMS.VendorRow[]) => {

                this.form.PartyId.value = selectedItems[0].LedgerId.toString();
                this.form.LedgerName.value = selectedItems[0].LedgerName;

                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = selectedItems[0].CostPricegroupId == null ? 0 : selectedItems[0].CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = selectedItems[0].StnAddMkp == null ? 0 : selectedItems[0].StnAddMkp;
                this.form.ItemDetails.LaborMarkup = selectedItems[0].LbrAddMkp == null ? 0 : selectedItems[0].LbrAddMkp;
                this.form.ItemDetails.LaborListId = selectedItems[0].LbrPricegroupId == null ? 0 : selectedItems[0].LbrPricegroupId;

                this.form.GstVat.value = selectedItems[0].GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            }
            pickerDialog.dialogOpen();

        }

        private CalculateAmountandTax(Items: any, ItemTotal: number, TotalItems: number) {

            var codearray = [];
            var amtarray = []; var gramt = 0; var ntamt = 0; var disc = 0; var pcs = 0; var wt = 0; var nwt = 0;

            //Items.forEach(function (x)
            for (var x of Items) {
                ntamt += x.NetAmount || 0;
                gramt += x.GrossAmount || 0;
                disc += x.Discount || 0;

                pcs += x.Pieces || 0;
                wt += x.Weight || 0;
                nwt += x.NetWeight || 0;


                var temp = false;
                for (let i = 0; i < codearray.length; i++) {
                    if (codearray[i] == x.HSN) {
                        amtarray[i] += x.GrossAmount || 0;
                        temp = true;
                    }
                }

                if (!temp) {
                    codearray.push(x.HSN);
                    amtarray.push(x.GrossAmount);
                }
                ItemTotal++;
            };

            this.form.NetAmount.value = gramt;
            this.form.Discount.value = disc;

            var TaxAmount = 0;

            var TaxApplicable = OMS.VoucherMasterRow.getLookup().items.filter(x => x.VoucherTypeId == this.form.VoucherTypeId.value)[0].IsTaxApplicable;

            if (ItemTotal == TotalItems && TaxApplicable) {

                this.form.GrossAmount.value = gramt + TaxAmount;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;
            }
            else {
                this.form.GrossAmount.value = gramt;

                this.form.Pieces.value = pcs;
                this.form.Weight.value = wt;
                this.form.NetWeight.value = nwt;

            }


        }



        protected onDialogOpen() {
            super.onDialogOpen();


            if (this.form.PartyId.value != "") {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
                let PartyDetails;
                OMS.VendorService.Retrieve({
                    EntityId: parseInt(this.form.PartyId.value)
                }, response => {
                    PartyDetails = response.Entity
                }, { async: false });
                this.form.ItemDetails.PartyId = parseInt(this.form.PartyId.value);
                this.form.ItemDetails.RateListId = PartyDetails.CostPricegroupId == null ? 0 : PartyDetails.CostPricegroupId;
                this.form.ItemDetails.StoneMarkup = PartyDetails.StnAddMkp == null ? 0 : PartyDetails.StnAddMkp;
                this.form.ItemDetails.LaborMarkup = PartyDetails.LbrAddMkp == null ? 0 : PartyDetails.LbrAddMkp;
                this.form.ItemDetails.LaborListId = PartyDetails.LbrPricegroupId == null ? 0 : PartyDetails.LbrPricegroupId;
                this.form.LedgerName.value = PartyDetails.LedgerName;
                this.form.GstVat.value = PartyDetails.GstVat;
                let AddressDetails: OMS.AddressMasterRow;
                OMS.AddressMasterService.GetAddress({
                    LedgerId: parseInt(this.form.PartyId.value)
                },
                    response =>
                        AddressDetails = response.Entity,
                    { async: false }
                );

                if (AddressDetails != null) {
                    this.form.State.value = AddressDetails.StateName;
                    this.form.Country.value = AddressDetails.CountryName;
                    var city = AddressDetails.CityName;
                    let address = AddressDetails.Address1 + ", " + AddressDetails.Address2 + ", " + city + ", "
                        + this.form.State.value + ", " + this.form.Country.value + ", " + AddressDetails.Pincode;
                    this.form.Address1.value = address;

                }
            } else {
                var ExchangeDetails = OMS.ExchangeRateRow.getLookup().items.filter(x => x.CurrencyId.toString() == this.form.CurrencyId.value && x.FromDate <= this.form.TransDate.value && x.ToDate >= this.form.TransDate.value)[0];
                this.form.ExchRate.value = ExchangeDetails.ExchRate;
            }

            this.form.NetAmount.getGridField().toggle(false);
            this.form.TaxAmount.getGridField().toggle(false);
            this.form.AdditionalCharges.getGridField().toggle(false);
            this.form.GrossAmount.getGridField().toggle(false);
            this.form.Discount.getGridField().toggle(false);
        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            var btnDelete = Q.first(btns, x => x.cssClass == "delete-button");

            var oldDeleteClick = btnDelete.onClick;

            btnDelete.onClick = e => { this.confirmBeforeDelete(oldDeleteClick, e); };


            var postingpermission = Q.Authorization.hasPermission('Sales:Material:Posting');
            //Export PDF Button
            btns.push({
                title: 'Post',
                icon: 'las la-check-double',
                cssClass: 'approve-doc-button',
                onClick: () => {
                    var entity = this.entity;
                    entity.AutoPosting = true; delete entity.TransDate;

                    MaterialOutService.Update({ Entity: entity, EntityId: entity.TransId }, response => {
                        if (response.Error == null) {
                            this.dialogClose();
                            Serenity.SubDialogHelper.triggerDataChange(this);
                        }
                    }, { async: false })
                },
                visible: postingpermission

            });


            return btns;
        }

        // **** Validate Reference of Voucher in Stock Transaction Before Delete. ****
        private confirmBeforeDelete(oldEvt, e) {
            let self = this;
            let refid: Stock.StockItemRow;
            Stock.StockItemService.CheckTransaction(
                { RefTransId: parseInt(this.form.TransId.value), RefVoucherId: this.form.VoucherTypeId.value },
                response => {
                    if (response.Entities != null && response.Entities.length > 0)
                        refid = response.Entities[0];
                }, { async: false }
            )

            if (refid != null) {
                if (refid.PartyId != null || refid.PartyId > 0) {
                    Q.alert("This Voucher has been used in transactions Can Not Delete!");
                    return;
                }
            } else {
                MaterialOutService.Delete(
                    {
                        EntityId: this.entityId
                    }, response => {
                        Serenity.SubDialogHelper.triggerDataChange(self);
                        self.dialogClose();
                        window.setTimeout(() => Q.notifySuccess(Q.text('Deleted successfully')), 0);
                    });
            }

        }
    }
}